module.exports = ".btn-actions {\n  border: none;\n  overflow: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/productos-financieros/productos-financieros.component.scss
// module id = ./src/app/administracion/productos-financieros/productos-financieros.component.scss
// module chunks = main